import React from 'react';

const VARIANTS = {
  primary: 'bg-brand text-white hover:bg-brand-dark shadow-[0_8px_24px_-8px_rgba(124,58,237,0.7)] hover:-translate-y-0.5',
  outlineDark: 'border border-white/30 text-white hover:bg-white/10 hover:border-white/60',
  outlineLight: 'border border-brand/60 text-brand hover:bg-brand hover:text-white',
  ghost: 'text-white/80 hover:text-white hover:bg-white/10',
};

const SIZES = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-6 py-3 text-sm',
  lg: 'px-7 py-3.5 text-[15px]',
};

const Button = ({ variant = 'primary', size = 'md', children, className = '', ...props }) => (
  <button
    className={`inline-flex items-center justify-center gap-2 font-semibold rounded-full transition-[background-color,color,transform,box-shadow,border-color] duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/60 ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
    {...props}
  >
    {children}
  </button>
);

export default Button;
